import { pathOr } from "ramda";
import { GRAPH_URL } from "../../../constants";

const query = `
  mutation CreateStoryImage(
    $sourceId: ID!
    $withWatermark: Boolean
    $hideTotalLikes: Boolean
    $hidePostLikes: Boolean
    $hideStats: Boolean
    $hideSummaryCaption: Boolean 
  ){
    createStoryWithSettings(
      sourceId: $sourceId
      withWatermark: $withWatermark
      hideTotalLikes: $hideTotalLikes
      hidePostLikes: $hidePostLikes
      hideStats: $hideStats
      hideSummaryCaption: $hideSummaryCaption
    ) {
      storyWithWatermark {
        uri
      }
      story {
        uri
      }
    }
  }
`;

const getStoryImage = variables =>
  fetch(GRAPH_URL, {
    method: 'POST',
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ query, variables })
  })
    .then(res => res.json())
    .then(res => {
      const storyUrl = pathOr(null, ['data', 'createStoryWithSettings', 'story', 'uri'])(res);
      const storyWithWatermarkUrl = pathOr(null, [
        'data',
        'createStoryWithSettings',
        'storyWithWatermark',
        'uri',
      ])(res);
      return { storyUrl, storyWithWatermarkUrl };
    });

export default getStoryImage;